<template>
  <div>
    <div
      :class="[
        'isButton',
        $style.wrapper
      ]"
      @click="handleOpen"
    >
      <b-img
        :src="require(`@/assets/images/${gameTypeIcon}`)"
        :class="$style.switchIcon"
      />
    </div>

    <transition name="slide-top">
      <div
        v-if="isMenuOpen"
        v-click-outside="handleOutsideClick"
        :class="$style.switcher"
        :style="menuStyle"
      >
        <b-container>
          <b-row>
            <b-col
              :cols="12"
              class="text-center pt-5"
            >
              <BaseTextH2>{{ $t('change-game-type') }}</BaseTextH2>
            </b-col>
            <b-col
              :class="[
                'd-flex flex-column py-4 align-items-center',
              ]"
              @click="handleSelectGameType('summer')"
            >
              <div
                :class="[
                  'p-2 d-flex flex-column justify-content-center align-items-center flex-fill w-100',
                  $style.selectButton,
                  gameType === 'summer' && $style.isSelected
                ]"
              >
                <b-img
                  :src="require(`@/assets/images/skor_logo_${$i18n.locale}.svg`)"
                  :class="$style.logo"
                  fluid
                />
              </div>
            </b-col>
            <b-col
              :class="[
                'd-flex flex-column py-4 align-items-center',
              ]"
              @click="handleSelectGameType('classic')"
            >
              <div
                :class="[
                  'p-2 d-flex flex-column justify-content-center align-items-center flex-fill w-100',
                  $style.selectButton,
                  gameType !== 'summer' && $style.isSelected
                ]"
              >
                <b-img
                  :src="require(`@/assets/images/logo-black-${$i18n.locale}.svg`)"
                  :class="$style.logo"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import BaseTextH2 from '@/components/Atoms/Typography/BaseTextH2'
export default {
  name: 'TheGameTypeSwitcher',
  components: { BaseTextH2 },
  directives: {
    'click-outside': {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) {
            warn += `Found in component '${compName}'`
          }

          console.warn(warn)
        }
        setTimeout(() => {
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler
          // add Event Listeners
          document.addEventListener('click', handler)
        }, 350)
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      },
    },
  },
  data() {
    return {
      isMenuOpen: false,
      menuStyle: {
        top: `40px`,
      },
    }
  },
  computed: {
    ...mapState({
      gameType: state => state['game/type'].type,
    }),
    gameTypeIcon() {
      if (this.gameType === 'summer') {
        return 'logo-skor.png'
      }
      return 'logo-pick8.png'
    },
  },
  methods: {
    ...mapActions({
      setGameType: 'game/type/setGameType',
    }),
    handleOpen() {
      const offset = document.getElementById('navbar').offsetHeight + document.getElementById('navbar').offsetTop
      this.menuStyle = {
        top: `${offset}px`,
      }
      this.isMenuOpen = true
    },
    handleOutsideClick() {
      if (this.isMenuOpen) {
        this.isMenuOpen = false
      }
    },
    handleSelectGameType(type) {
      this.setGameType({ type })
      if (!['home', 'closed-rounds'].includes(this.$route.name)) {
        this.$router.push({
          name: 'home',
        })
      }
      this.isMenuOpen = false
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";

  .wrapper {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .switchIcon {
    height: 28px;
    width: 28px;
  }
  .logo {
    max-height: 125px;
  }
  .switcher {
    position: fixed;
    left: 0;
    width: 100vw;
    z-index: 5;
    background-color: $color-white;
    color: $color-midnight-blue;
    box-shadow: 0 3px 20px 5px rgba(0,0,0,.05);
    .selectButton {
      border-radius: .5rem;
      cursor: pointer;
    }
    .isSelected {
      box-shadow: 0 0 7px 0 transparentize($color-wet-weather, .5);;
    }
  }

</style>
